import React from 'react';
import { Link } from 'react-router-dom';

const PartnersBanner: React.FC = () => {
  return (
    <section className="py-16 bg-amber-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h3 className="text-3xl font-display font-bold text-gray-900 mb-3">
            Our Trusted Partners
          </h3>
          <div className="w-20 h-1 bg-amber-500 mx-auto rounded-full mb-4"></div>
          <p className="text-gray-600 max-w-3xl mx-auto mb-8">
            We collaborate with leading conservation organizations and tourism boards 
            to deliver exceptional safari experiences
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-8 mb-8">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex space-x-4 md:space-x-8">
              <div className="group relative w-24 h-24 md:w-28 md:h-28 rounded-lg overflow-hidden border-2 border-amber-100 transition-all hover:border-amber-500">
                <img 
                  src="/partners/WhatsApp Image 2025-02-27 at 11.47.19.jpeg" 
                  alt="Gondwana Collection" 
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-amber-800/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center p-2">
                  <span className="text-white text-xs font-medium text-center">Gondwana Collection</span>
                </div>
              </div>
              
              <div className="group relative w-24 h-24 md:w-28 md:h-28 rounded-lg overflow-hidden border-2 border-amber-100 transition-all hover:border-amber-500">
                <img 
                  src="/partners/WhatsApp Image 2025-02-27 at 11.48.06.jpeg" 
                  alt="Namibia Tourism Board" 
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-amber-800/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center p-2">
                  <span className="text-white text-xs font-medium text-center">Namibia Tourism Board</span>
                </div>
              </div>
            </div>
            
            <div className="flex space-x-4 md:space-x-8">
              <div className="group relative w-24 h-24 md:w-28 md:h-28 rounded-lg overflow-hidden border-2 border-amber-100 transition-all hover:border-amber-500">
                <img 
                  src="/partners/WhatsApp Image 2025-02-27 at 11.49.26.jpeg" 
                  alt="Tour & Safari Association" 
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-amber-800/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center p-2">
                  <span className="text-white text-xs font-medium text-center">Tour & Safari Association</span>
                </div>
              </div>
              
              <div className="group relative w-24 h-24 md:w-28 md:h-28 rounded-lg overflow-hidden border-2 border-amber-100 transition-all hover:border-amber-500">
                <img 
                  src="/partners/WhatsApp Image 2025-02-27 at 11.51.42.jpeg" 
                  alt="Save The Rhino Trust Namibia" 
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-amber-800/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center p-2">
                  <span className="text-white text-xs font-medium text-center">Save The Rhino Trust</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <Link 
            to="/about#partners" 
            className="inline-flex items-center gap-2 px-6 py-3 bg-amber-700 text-white font-medium rounded-lg hover:bg-amber-800 transition-colors"
          >
            <span>Learn more about our partnerships</span>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PartnersBanner; 